import axios from 'axios';
import { toast } from 'react-toastify';
import {
  EXTERNAL_API_SEND_MOCK_DATA_REQUEST_BEGIN,
  EXTERNAL_API_SEND_MOCK_DATA_REQUEST_SUCCESS,
  EXTERNAL_API_SEND_MOCK_DATA_REQUEST_FAILURE,
  EXTERNAL_API_SEND_MOCK_DATA_REQUEST_DISMISS_ERROR,
} from './constants';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';

export function sendMockDataRequest(args = {}) {
  return (dispatch) => {
    dispatch({
      type: EXTERNAL_API_SEND_MOCK_DATA_REQUEST_BEGIN,
    });
    const { projectId, version } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/external-api/rest-api`,
        args,
        header,
      );
      doRequest.then(
        (res) => {
          if (res.status === 200 && res.data) {
            dispatch({
              type: EXTERNAL_API_SEND_MOCK_DATA_REQUEST_SUCCESS,
              data: res.data,
            });
            resolve(res);
          } else {
            dispatch({
              type: EXTERNAL_API_SEND_MOCK_DATA_REQUEST_FAILURE,
              data: { error: 'Failed' },
            });
            const errMsg = getErrorMessageFromResponse(res);
            toast.error(`Failed: ${errMsg}`, {});
            reject('Failed');
          }
          resolve(res);
        },
        (err) => {
          dispatch({
            type: EXTERNAL_API_SEND_MOCK_DATA_REQUEST_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissSendMockDataRequestError() {
  return {
    type: EXTERNAL_API_SEND_MOCK_DATA_REQUEST_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case EXTERNAL_API_SEND_MOCK_DATA_REQUEST_BEGIN:
      return {
        ...state,
        sendMockDataRequestPending: true,
        sendMockDataRequestError: null,
      };

    case EXTERNAL_API_SEND_MOCK_DATA_REQUEST_SUCCESS:
      return {
        ...state,
        sendMockDataRequestPending: false,
        sendMockDataRequestError: null,
        responseData: action.data ? action.data : null,
      };

    case EXTERNAL_API_SEND_MOCK_DATA_REQUEST_FAILURE:
      return {
        ...state,
        sendMockDataRequestPending: false,
        sendMockDataRequestError: action.data.error,
      };

    case EXTERNAL_API_SEND_MOCK_DATA_REQUEST_DISMISS_ERROR:
      return {
        ...state,
        sendMockDataRequestError: null,
      };

    default:
      return state;
  }
}
